import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../components/ui/select';

export interface ServiceDeskOption {
  id: number;
  label: string;
}

interface IssuesServiceDeskSelectProps {
  value: number;
  onChange: (id: number) => void;
  options: ServiceDeskOption[];
  isLoading?: boolean;
}

export const IssuesServiceDeskSelect = ({
  value,
  onChange,
  options,
  isLoading,
}: IssuesServiceDeskSelectProps) => {
  const { t } = useTranslation();

  return (
    // First control of the compact filter row: the trigger carries the name, no stacked label.
    <Select
      value={value ? String(value) : undefined}
      onValueChange={(next) => onChange(Number(next))}
      disabled={isLoading || options.length === 0}
    >
      <SelectTrigger className="h-[38px] w-[188px] rounded-[9px] text-[13px]" aria-label={t('Service desk')}>
        <SelectValue placeholder={isLoading ? t('Loading…') : t('Choose a service desk')} />
      </SelectTrigger>
      <SelectContent>
        {options.map((sd) => (
          <SelectItem key={sd.id} value={String(sd.id)}>
            {sd.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
